import { translate } from 'javascripts/translations/i18n';

type DelayOption = {
  label: string;
  value: string;
};

export const delayOptions: DelayOption[] = [
  { label: translate('reminders.delay.firstOption'), value: '1800' },
  { label: translate('reminders.delay.secondOption'), value: '14400' },
  { label: translate('reminders.delay.thirdOption'), value: '86400' },
  { label: translate('reminders.delay.fourthOption'), value: '259200' },
];
